import React, { useState, useEffect } from "react";
import { FaExchangeAlt, FaSearch } from "react-icons/fa";
import axios from "axios";
import { url } from "../utils/config.js";
import { RxCross2 } from "react-icons/rx";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import formatNumberToUs from "../custom_functions/formatNumberToUs.js";

function B2BWorkOrderAuditLog() {
  const [workOrders, setWorkOrders] = useState([]);
  const [selectedWorkOrder, setSelectedWorkOrder] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [selectedWorkOrderLogs, setSelectedWorkOrderLogs] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [isSearchMode, setIsSearchMode] = useState(false);

  const pageSize = 5;


  const getAllWorkOrders = async (page) => {
    try {
      setIsSearchMode(false);
      const reqUrl = url + "/fleet_work_order/" + page + "/" + pageSize;
      const token = window.localStorage.getItem("token");
      const headers = { authorization: `bearer ${token}` };
      const response = await axios.get(reqUrl, { headers });
      setWorkOrders(response.data.data);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      toast.error("Error fetching work orders", { autoClose: 3000 });
    }
  };

  const searchWorkOrder = async (searchValue) => {
    try {
      setIsSearchMode(true);
      const reqUrl = url + "/fleet_work_order/" + searchValue;
      const token = window.localStorage.getItem("token");
      const headers = { authorization: `bearer ${token}` };
      const response = await axios.get(reqUrl, { headers });
      if (response.data.status) {
        setWorkOrders([]);
        setSelectedWorkOrderLogs([]);
        setSelectedWorkOrder(null)
        return toast.error(response.data.status, { autoClose: 3000 });
      }

      if (response.data.data) {
        setWorkOrders(response.data.data);
      } else {
        toast.error("No work wrder found", { autoClose: 3000 });
        setWorkOrders([]);
        setSelectedWorkOrderLogs([]);
      }
    } catch (error) {
      toast.error("Search failed", { autoClose: 3000 });
    }
  };

  const getWorkOrderById = async (workOrderId) => {
    try {
      setSelectedWorkOrderLogs([]);
      const reqUrl = url + "/get_work_order_logs/" + workOrderId + "?type=b2b";
      const token = window.localStorage.getItem("token");
      const headers = { authorization: `bearer ${token}` };
      const response = await axios.get(reqUrl, { headers });
      setSelectedWorkOrderLogs(response.data.data || []);
    } catch (error) {
      toast.error("Error fetching logs", { autoClose: 3000 });
    }
  };

  useEffect(() => {
    if (selectedWorkOrder) {
      getWorkOrderById(selectedWorkOrder);
    }
  }, [selectedWorkOrder]);


  useEffect(() => {
    getAllWorkOrders(currentPage);
  }, [currentPage]);

  return (

    <div className='grid grid-cols-12 gap-6 h-[calc(100vh-200px)]'>
      <div className='col-span-4'>
        <div className='bg-white rounded-lg border border-gray-200 h-full flex flex-col'>
          <div className="p-4 border-b border-gray-200 flex items-center gap-2">
            <input
              type="text"
              placeholder="Apoointment ID"
              className="py-2 focus:outline-none rounded-full border-r border-gray-300 text-xs"
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  setCurrentPage(1);
                  searchWorkOrder(searchValue);
                }
              }}
            />
            <button
              className="p-2 rounded-full bg-blue-500 text-white hover:bg-blue-600"
              onClick={() => {
                setCurrentPage(1);
                searchWorkOrder(searchValue);
              }}
            >
              <FaSearch size={12} />
            </button>
            <button
              className="p-2 rounded-full bg-red-500 text-white hover:bg-red-600"
              onClick={() => {
                setSearchValue("");
                getAllWorkOrders(1);
                setSelectedWorkOrderLogs([]);
                setIsSearchMode(false);
              }}
            >
              <RxCross2 size={12} />
            </button>
          </div>

          <div className='flex-1 p-4 space-y-3 overflow-y-auto' style={{ maxHeight: 'calc(100vh - 250px)' }}>
            {workOrders.length > 0 && workOrders.map((workOrder) => (
              <div
                key={workOrder.id}
                className={`p-4 rounded-lg border cursor-pointer transition-all duration-200 ${selectedWorkOrder === workOrder.id
                  ? "border-blue-500 bg-blue-50 shadow-md"
                  : "border-gray-200 hover:border-gray-300 hover:shadow-sm"
                  }`}
                onClick={() => setSelectedWorkOrder(workOrder.id)}
              >
                <div className='flex justify-between items-start'>
                  <span className='font-semibold text-gray-900 text-xs'>Work Order ID: {workOrder?.id}</span>
                  <span className="bg-green-200 rounded-lg px-2 text-xs"> FAP0000{workOrder.booking_id}</span><br />
                </div>
                <p className='text-xs font-medium text-gray-700 mb-1'>
                  Name: {workOrder?.fleet_booking?.fleet_customer?.name}<br />
                  Email: {workOrder?.fleet_booking?.fleet_customer?.email}<br />
                  Address: {workOrder?.fleet_booking?.fleet_customer?.address}<br />
                  Phone: {workOrder?.fleet_booking?.fleet_customer?.phone}
                </p>
                <div className="flex items-center justify-between gap-2 md:flex-col md:items-start md:gap-0">
                  <p className='text-xs text-gray-600 '>
                    {workOrder?.fleet_customer_car.make}
                    <span className='mx-2'>•</span>
                    {workOrder?.fleet_customer_car.model}
                    <span className='mx-2'>•</span>
                    {workOrder?.fleet_customer_car.year}
                  </p>
                  <p className=" text-black-600 text-xs">VIN: {workOrder?.fleet_customer_car.vin}</p>
                </div>
              </div>
            ))}
          </div>

          {!isSearchMode && (
            <div className="p-4 border-t border-gray-200 flex flex-col sm:flex-row items-center justify-between gap-2">
              <button
                className={`px-2 py-1 text-xs sm:px-3 sm:py-1 sm:text-sm rounded-md border font-medium ${currentPage === 1
                  ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                  : "bg-white text-gray-700 hover:bg-gray-100"
                  }`}
                onClick={() => {
                  if (currentPage > 1) setCurrentPage(currentPage - 1);
                }}
                disabled={currentPage === 1}
              >
                Previous
              </button>

              <div className="flex items-center gap-1 sm:gap-2 overflow-x-auto flex-nowrap scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100">
                {(() => {
                  const pages = [];
                  let startPage = Math.max(1, currentPage - 2);
                  let endPage = Math.min(totalPages, currentPage + 2);
                  if (currentPage <= 3) {
                    endPage = Math.min(5, totalPages);
                  } else if (currentPage >= totalPages - 2) {
                    startPage = Math.max(1, totalPages - 4);
                  }
                  if (startPage > 1) {
                    pages.push(<span key="start-ellipsis" className="px-1 text-xs sm:px-2">...</span>);
                  }
                  for (let i = startPage; i <= endPage; i++) {
                    pages.push(
                      <button
                        key={i}
                        className={`w-7 h-7 text-xs sm:w-8 sm:h-8 sm:text-sm rounded-full flex items-center justify-center font-medium ${currentPage === i
                          ? "bg-blue-500 text-white"
                          : "bg-white text-gray-700 hover:bg-gray-100"
                          }`}
                        onClick={() => setCurrentPage(i)}
                      >
                        {i}
                      </button>
                    );
                  }
                  if (endPage < totalPages) {
                    pages.push(<span key="end-ellipsis" className="px-1 text-xs sm:px-2">...</span>);
                  }
                  return pages;
                })()}
              </div>

              <button
                className={`px-2 py-1 text-xs sm:px-3 sm:py-1 sm:text-sm rounded-md border font-medium ${currentPage === totalPages
                  ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                  : "bg-white text-gray-700 hover:bg-gray-100"
                  }`}
                onClick={() => {
                  if (currentPage < totalPages) setCurrentPage(currentPage + 1);
                }}
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
          )}
        </div>
      </div>

      <div className='col-span-8'>
        <div className='bg-white rounded-lg border border-gray-200 h-full flex flex-col'>
          {/* Placeholder for work order log details */}
          <div className='p-4 overflow-y-auto flex-1'>
            {selectedWorkOrderLogs?.length > 0 ? (
              selectedWorkOrderLogs.map((item, index) => (
                <div
                  key={index}
                  className="w-full bg-gray-50 rounded-lg shadow-sm p-4 mb-4 border border-gray-200"
                >
                  <div className="flex flex-wrap items-center gap-3 mb-2 text-sm justify-between">
                    <span className="font-semibold"># {item?.workOrderId}</span>

                    <span className="inline-flex items-center px-3 py-1 rounded-full font-semibold bg-purple-100 text-purple-700">
                      Version 1.{selectedWorkOrderLogs.length - index - 1}
                    </span>
                    <FaExchangeAlt />
                    <span className="font-medium">Technician: {item?.firstName} {item?.lastName}</span>
                    <span className="text-xs">
                      {new Date(item.createdAt).toLocaleString("en-US", {
                        year: "numeric",
                        month: "2-digit",
                        day: "2-digit",
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: true
                      }).replace(/\//g, "-")
                        .replace(",", "")}
                    </span>
                  </div>

                  <hr className="my-2 border-gray-300" />

                  <div className="text-sm text-gray-600">
                    {item.totalTax.new !== item.totalTax.previous && (
                      <div className="flex items-center gap-3 text-sm text-gray-800">
                        <div className="bg-blue-100 text-blue-700 text-xs font-semibold px-3 py-1 rounded-full">
                          Modified Total Tax
                        </div>
                        <span className="text-gray-600">
                          ${formatNumberToUs(item.totalTax.previous)} &rarr; ${formatNumberToUs(item.totalTax.new || 0)}
                        </span>
                      </div>
                    )}

                    {item.totalDiscount.new !== item.totalDiscount.previous && (
                      <div className="flex items-center gap-3 text-sm text-gray-800">
                        <div className="bg-blue-100 text-blue-700 text-xs font-semibold px-3 py-1 rounded-full">
                          Modified Total Discount
                        </div>
                        <span className="text-gray-600">
                          ${formatNumberToUs(item.totalDiscount.previous)} &rarr;  ${formatNumberToUs(item.totalDiscount.new || 0)}
                        </span>
                      </div>
                    )}

                    {item.totalCostFinal.new !== item.totalCostFinal.previous && (
                      <div className="flex items-center gap-3 text-sm text-gray-800">
                        <div className="bg-blue-100 text-blue-700 text-xs font-semibold px-3 py-1 rounded-full">
                          Modified Total Cost
                        </div>
                        <span className="text-gray-600">
                          ${formatNumberToUs(item.totalCostFinal.previous)} &rarr; ${formatNumberToUs(item.totalCostFinal.new || 0)}
                        </span>
                      </div>
                    )}


                    {item.materialList?.data?.map((material, index) => (
                      <div className="flex items-center gap-3 text-sm text-gray-800" key={index}>
                        <div className="bg-green-100 text-blue-700 text-xs font-semibold px-3 py-1 rounded-full">
                          Added  Material
                        </div>
                        <span className="text-gray-600">
                          {material.name} ${formatNumberToUs(material.cost)}
                        </span>
                      </div>
                    ))}
                    {item.deletedMaterialList?.data?.map((material, index) => (
                      <div className="flex items-center gap-3 text-sm text-gray-800" key={index}>
                        <div className="bg-red-500 text-white text-xs font-semibold px-3 py-1 rounded-full">
                          Removed Material
                        </div>
                        <span className="text-gray-600">
                          {material.name} ${formatNumberToUs(material.cost || 0)}
                        </span>
                      </div>
                    ))}

                    {item.otherList?.data?.map((material, index) => (
                      <div className="flex items-center gap-3 text-sm text-gray-800" key={index}>
                        <div className="bg-green-100 text-blue-700 text-xs font-semibold px-3 py-1 rounded-full">
                          Added Other Service
                        </div>
                        <span className="text-gray-600">
                          {material.name} {material.cost && `$${formatNumberToUs(material.cost)}`}
                        </span>
                      </div>
                    ))}
                    {item.deletedOtherList?.data?.map((material, index) => (
                      <div className="flex items-center gap-3 text-sm text-gray-800" key={index}>
                        <div className="bg-red-500 text-white text-xs font-semibold px-3 py-1 rounded-full">
                          Removed Other Service
                        </div>
                        <span className="text-gray-600">
                          {material.name} {material.cost && `$${formatNumberToUs(material.cost)}`}
                        </span>
                      </div>
                    ))}

                    {item.serviceList?.data?.map((material, index) => (
                      <div className="flex items-center gap-3 text-sm text-gray-800" key={index}>
                        <div className="bg-green-100 text-blue-700 text-xs font-semibold px-3 py-1 rounded-full">
                          Added Service List
                        </div>
                        <span className="text-gray-600">
                          {material.name} {material.cost && `$${formatNumberToUs(material.cost)}`}
                        </span>
                      </div>
                    ))}
                    {item.deletedServiceList?.data?.map((material, index) => (
                      <div className="flex items-center gap-3 text-sm text-gray-800" key={index}>
                        <div className="bg-red-500 text-white text-xs font-semibold px-3 py-1 rounded-full">
                          Removed Service List
                        </div>
                        <span className="text-gray-600">
                          {material.name} {material.cost && `$${formatNumberToUs(material.cost)}`}
                        </span>
                      </div>
                    ))}

                    {item.bundleList?.data?.map((material, index) => (
                      <div className="flex items-center gap-3 text-sm text-gray-800" key={index}>
                        <div className="bg-green-100 text-blue-700 text-xs font-semibold px-3 py-1 rounded-full">
                          Added Service Bundle
                        </div>
                        <span className="text-gray-600">
                          {material.name} {material.cost && `$${formatNumberToUs(material.cost)}`}
                        </span>
                      </div>
                    ))}
                    {item.deletedBundleList?.data?.map((material, index) => (
                      <div className="flex items-center gap-3 text-sm text-gray-800" key={index}>
                        <div className="bg-red-500 text-white text-xs font-semibold px-3 py-1 rounded-full">
                          Removed Service Bundle
                        </div>
                        <span className="text-gray-600">
                          {material.name} {material.cost && `$${formatNumberToUs(material.cost)}`}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>

              ))
            ) : (
              <p className="text-gray-500 text-sm text-center">No logs found.</p>
            )}


          </div>
        </div>
      </div>
    </div>

  );
}

export default B2BWorkOrderAuditLog;